// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { MultiSocketEndpoint } from "@lib/messaging/MultiSocketEndpoint";
import { SingleSocketEndpoint } from "@lib/messaging/SingleSocketEndpoint";

/**
 * Represents an endpoint from which messages can be received and sent.
 */
export type SocketEndpoint = SingleSocketEndpoint | MultiSocketEndpoint;